/**
 * Offline: dùng ĐÚNG hàm tick chung với heSoHieuSuat = 0,3 (P05).
 *
 * - Cap 10 giờ thực (P04): số giờ game = min(giờ vắng, 10) × 60.
 * - Chỉ bán hàng đang có (hết hàng thì dừng — đơn tự động vẫn đặt nếu đủ
 *   tiền, giao hàng vẫn đến). Lương tính 30% (P33).
 * - Trả về báo cáo để UI hiện khi người chơi mở lại.
 */
import { tick } from './dong-ho.js';
import { ngayMayTuGioGame } from './nhiem-vu.js';
import type { HamRng } from './rng.js';
import type { BaoCaoOffline, DuLieuGame, TrangThaiGame } from './types.js';

/**
 * Áp dụng tiến trình offline cho state. State bị thay đổi trực tiếp.
 * Trả về báo cáo tóm tắt kỳ offline.
 *
 * @param lucLuu mốc thời gian lưu (để nhiệm vụ hằng ngày reset đúng theo
 *               ngày máy trong kỳ offline; mặc định = bây giờ).
 */
export function apDungOffline(
  state: TrangThaiGame,
  duLieu: DuLieuGame,
  gioThucVang: number,
  rng: HamRng,
  lucLuu = new Date(),
): BaoCaoOffline {
  const gioTinh = Math.min(Math.max(gioThucVang, 0), duLieu.offline.capGioThuc);
  const soGioGame = Math.floor(gioTinh * 60);

  const xpDau = state.nguoiChoi.xp;
  const luongDau = state.thongKe.tongLuong;
  const laiGopDau = state.thongKe.tongLaiGop;
  const monDau = { ...state.thongKe.monDaBan };
  const lanChoNoDau = state.thongKe.lanChoNo;

  for (let i = 0; i < soGioGame; i++) {
    tick(state, duLieu, rng, {
      heSoHieuSuat: duLieu.offline.hieuSuat,
      ngayMay: ngayMayTuGioGame(lucLuu, i),
    });
  }

  const monDaBan: Record<string, number> = {};
  for (const [ma, sl] of Object.entries(state.thongKe.monDaBan)) {
    const chenh = sl - (monDau[ma] ?? 0);
    if (chenh > 0) monDaBan[ma] = chenh;
  }
  const monHetHang = Object.entries(state.kho)
    .filter(([ma, muc]) => muc.ton <= 0 && (monDaBan[ma] ?? 0) > 0)
    .map(([ma]) => ma)
    .sort();

  return {
    gioThucVang: gioTinh,
    gioGameDaChay: soGioGame,
    laiGop: state.thongKe.tongLaiGop - laiGopDau,
    luong: state.thongKe.tongLuong - luongDau,
    xp: state.nguoiChoi.xp - xpDau,
    monDaBan,
    monHetHang,
    lanChoNo: state.thongKe.lanChoNo - lanChoNoDau,
  };
}
